module.exports = __webpack_public_path__ + "assets/CentroidOfQuadrilateral.d94a3fa45962e740a49d4ae62081d499.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CentroidOfQuadrilateral.gmt
// module id = 911
// module chunks = 0